import React, { useState } from 'react';

// Styles & Assets
import styles from './UbikarePage.module.css';

const UbikarePage: React.FC = () => {

    return (
        <div id='bettercare-ubikare-id' className={`pageContainer ${styles.customPageContainer}`}>
            <div className={styles.container}>
                <h1>Ubikare Page</h1>
            </div>
        </div>
    );
};

export default UbikarePage;

